/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StorageConfigurationForKubernetesUserManaged extends models.StorageConfigurationBaseForKubernetes {
    getFixupPrototypeFunction() { return StorageConfigurationForKubernetesUserManaged.fixupPrototype; }

    static newInstance(model: Partial<StorageConfigurationForKubernetesUserManaged>): StorageConfigurationForKubernetesUserManaged {
        let obj = Object.assign(new StorageConfigurationForKubernetesUserManaged(), model);
        StorageConfigurationForKubernetesUserManaged.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StorageConfigurationForKubernetesUserManaged>): StorageConfigurationForKubernetesUserManaged {
        if (!model) return null;
        return StorageConfigurationForKubernetesUserManaged.newInstance(<StorageConfigurationForKubernetesUserManaged> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StorageConfigurationForKubernetesUserManaged) {
        if (!obj) return;

        models.StorageConfigurationForKubernetesUserManaged.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StorageConfigurationForKubernetesUserManaged): boolean {
        if (models.StorageConfigurationBaseForKubernetes.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, StorageConfigurationForKubernetesUserManaged.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
